import { Box, Breadcrumbs, LinearProgress, SxProps, Theme, Typography } from '@mui/material';
import { useMemo } from 'react';
import { SecondaryActionButton } from 'shared/components/secondary-button';
import { useQuoteListState } from 'shared/contexts/quotes-summary-context';
import { DeleteDialog } from './delete-dialog';
import { FeedbackDialog } from './feedback-dialog';
import { QuotesSummaryFilter } from './quotes-summary-filter';
import { QuotesSummaryTable } from './tables/quotes-summary-table';
import { useQuotesSummaryTableInstance } from './tables/quotes-summary-table-instance';

const mainContentStyles: SxProps<Theme> = {
  padding: 2,
};

const containerStyles: SxProps<Theme> = {
  paddingTop: 2,
};

export function QuotesSummary() {
  const { quoteTableState, setQuoteTableState, toggleDialog, quotes, isFetching, isLoading } = useQuoteListState();

  const loading = isFetching || isLoading;
  const quoteSummaryTableData = useMemo(() => {
    return quotes?.filteredQuotes ?? [];
  }, [quotes?.filteredQuotes]);

  const quotesSummaryTableInstance = useQuotesSummaryTableInstance(
    quoteSummaryTableData,
    quotes?.totalCount || 0,
    quoteTableState.tableState
  );

  return (
    <Box sx={mainContentStyles}>
      <Box style={{ display: 'flex', justifyContent: 'space-between', flexFlow: 'row' }}>
        <Breadcrumbs separator='>' aria-label='quotes summary'>
          <Typography color='text.primary'>Quoting</Typography>
        </Breadcrumbs>
        <SecondaryActionButton actionText='Submit feedback' onClick={toggleDialog} />
      </Box>
      <Box sx={containerStyles}>
        <Typography align='center' variant='h4'>
          Quote Summary
        </Typography>
        <Box sx={{ paddingTop: 2, paddingLeft: 1, paddingRight: 1 }}>
          <QuotesSummaryFilter quotesSummaryTableInstance={quotesSummaryTableInstance} />
          <Box sx={containerStyles}>
            {loading && <LinearProgress color='secondary' />}
            <QuotesSummaryTable
              instance={quotesSummaryTableInstance}
              setQuoteTableState={setQuoteTableState}
              totalCount={!!quotes?.totalCount ? quotes.totalCount : 0}
            />
          </Box>
        </Box>
      </Box>
      <FeedbackDialog />
      <DeleteDialog />
    </Box>
  );
}
